import { useState, useEffect, ReactNode } from 'react';
import i18n from '@/i18n/config';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isReady, setIsReady] = useState(i18n.isInitialized);

  useEffect(() => {
    if (i18n.isInitialized) {
      setIsReady(true);
      return;
    }

    const handleInitialized = () => {
      setIsReady(true);
    };

    i18n.on('initialized', handleInitialized);

    return () => {
      i18n.off('initialized', handleInitialized);
    };
  }, []);

  // While i18n hydrates, render nothing. The cold-start SplashGate (mounted
  // higher in the tree) covers the screen on first session, so users never
  // see a blank flash. Mid-session i18n is already initialized so this path
  // is effectively never hit.
  if (!isReady) {
    return null;
  }

  return <>{children}</>;
}
